import {
	Component, Input, Output, OnInit, OnChanges, SimpleChange, SimpleChanges, OnDestroy,
	ViewChild, EventEmitter, ChangeDetectorRef, AfterViewInit, ElementRef
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
import { IdentityService } from 'identity';
import { NavigationService } from 'netview';

@Component({
	selector: 'snmpif-history-dialog',
	templateUrl: './snmpifhistorydialog.component.html',
	styleUrls: ['./snmpifhistorydialog.component.scss']
})
export class SnmpIfHistoryDialogComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

	@Input()
	public visible: boolean;

	@Input()
	public monitorType: string;

	@Input()
	public deviceGuid: string;

	@Input()
	public monitorPolicyGuid: string;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onClose: EventEmitter<any>;
	
	constructor(private element: ElementRef,
		private monitorService: MonitorService,
		private messageService: MessageService,
		private identityService: IdentityService,
		private navService: NavigationService,
		private changeDetector: ChangeDetectorRef) {

		this.visible = false;
		this.monitorType = "";
		this.deviceGuid = "";
		this.monitorPolicyGuid = "";
		this.visibleChange = new EventEmitter<boolean>();
		this.onClose = new EventEmitter<any>();
	}

	public ngOnInit(): void {

	}

	public ngAfterViewInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public ngOnDestroy(): void {

	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onCloseClicked(): void {
		this.onClose.emit();
		this.hide();
	}

}
